module.exports = __webpack_public_path__ + "static/img/passo2.6cda4e8b.svg";